import React, { useState, useEffect } from 'react';
import { Row, Col, Collapse } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../../../assets/css/patrocinadores.css';
import { CaretRightOutlined, LeftOutlined } from '@ant-design/icons';
import Slider from "react-slick";
import { CaretLeftFilled, CaretRightFilled } from '@ant-design/icons';
import { Element } from 'react-scroll/modules';

import log_blanco from '../../../assets/images/sitio/03_Patrocinadores_sitio_IES/Ies_Lutron.png';
import banner from '../../../assets/images/2022/stands/interiores/completos/stands_ind_-lutron.jpg';

import img_wsp_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_chatea_az.png';
import img_wsp from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_chatea_az.png';
import img_email_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_mas_info_az.png';
import img_email from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_mas_info_az.png';
import img_wsp_en_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_-chat_az.png';
import img_wsp_en from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_-chat_az.png';
import img_email_en_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_moreinfo_az.png';
import img_email_en from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_moreinfo_az.png';

import btn_fb_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_fb_Az.png';
import btn_fb from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_fb_Az.png';
import btn_tw from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_twitter_Az.png';
import btn_tw_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_twitter_Az.png';
import btn_yt from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_youtube_az.png';
import btn_yt_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_youtube_az.png';
import btn_in from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_ig_az.png';
import btn_in_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_ig_az.png';
import btn_lk from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_linkedin_az.png';
import btn_lk_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_linkedin_az.png';


const Lutron = (props) => {
  const { Panel } = Collapse;
  const { idioma, onMetrica, nombre } = props;
  const [hover_imagen, setHoverImagen] = useState(0);
  const [hover_redes, setHoverRedes] = useState(0);
  //let navigate = useNavigate(); 


  const ref_carousel = React.createRef();
  const [activar_carouse, setActivaCarosel] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const cambiarCarousel = (adelante) => {
    if(adelante){
        if(activar_carouse === 4){
          setActivaCarosel(1);
        }else{
          setActivaCarosel(activar_carouse+1);
        }
        ref_carousel.current.slickNext();
    }else{
        if(activar_carouse === 0){
          setActivaCarosel(4);
        }else{
          setActivaCarosel(activar_carouse-1);
        }
        ref_carousel.current.slickPrev();
    }
    
    }

  return (
    <>
     <Row align='middle'>
        <Col span={24}>
          <br /><br /><br /><br />
        </Col>
        <Col xs={{ span: 4, offset: 1 }} md={{ span: 2, offset: 2 }}>
                  <p className="salir_patrocinador">
          <Link to="/#patrocinadores" className="salir_patrocinador"><LeftOutlined /> {idioma === 'es' ? 'Salir' : 'Get out'}</Link>
          </p>
        </Col>
        <Col xs={{ span: 8, offset: 1 }} md={{ span: 4, offset: 5 }}>
          {idioma==='es' ?
            <img src={log_blanco} style={{width:'100%'}} />
          :
          <img src={log_blanco} style={{width:'100%'}} />}
        </Col>
      </Row>
      <Row align="middle">
      <Col span={24} offset={0}>
        <a href="#video" onClick={()=>{onMetrica('video',nombre)}}>
          <img src={banner} style={{width:'100%'}} />
        </a>
        <br /><br />
        </Col>
        <Col span={20} offset={2}>
          {idioma === 'es' ?
          <p className="texto_patrocinadores">
            <span className='color_verde'><strong>SOBRE NOSOTROS</strong></span>
            <br />
          <a target="_blank" className="texto_patrocinadores_link" href="https://www.lutron.com/es-LA/paginas/default.aspx">LUTRON</a> es un líder en la industria de control de iluminación artificial con equipos de control de diferentes tecnologías y el control de la iluminación se hace mediante el uso de persianas automatizadas. 
          <br /><br />
          Cuenta con un portafolio muy amplio de productos cableados e inalámbricos que pueden otorgar una solución en de un pequeño espacio.
        </p>
        :
        <p className="texto_patrocinadores">
          <span className='color_verde'><strong>ABOUT OUS</strong></span><br />
          <a target="_blank" className="texto_patrocinadores_link" href="https://www.lutron.com/es-LA/paginas/default.aspx">LUTRON</a> is a leader in the artificial lighting control industry with different technology control equipment and lighting control is done through the use of automated blinds.
          <br /><br />
          It has a very broad portfolio of wired and wireless products that can provide a solution in a small space.
        </p>}

        </Col>
        <Col span={2} offset={2} >
          <CaretLeftFilled className="flecha_agenda" onClick={() => {cambiarCarousel(false);}}/>
          </Col>

        <Element name="#video"/>
        <Col span={16} offset={0}  onClick={()=>onMetrica('video',nombre)}>
          
        <br />
        <Slider ref={ref_carousel} {...settings}>
          
        <div className="contenedor_video_patrocinador">
        <iframe className="video" src="https://www.youtube.com/embed/0ixmKh3HuMc?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          <div className="contenedor_video_patrocinador">
        <iframe className="video" src="https://www.youtube.com/embed/szjYHNRwVEo?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          <div className="contenedor_video_patrocinador">
        <iframe className="video" src="https://www.youtube.com/embed/gT0-XalSdeE?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          <div className="contenedor_video_patrocinador">
        <iframe className="video" src="https://www.youtube.com/embed/RRXYSCkHROA?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          </Slider>
          <br /><br />
        </Col>
        <Col span={2}>
          <CaretRightFilled className="flecha_agenda" onClick={() => {cambiarCarousel(true);}}/>
          </Col>
        <Col xs={{span:20, offset:2}} md={{span:8, offset:4}} className="paddin_20">
          {idioma === 'es' ?
          <a  onClick={()=>onMetrica('whatsapp',nombre)} target="_blank" href="https://api.whatsapp.com/send?phone=525513042767&text=Hola,%20me%20contacto%20desde%20el%20stand%20de%20Lutron%20de%20la%20IES." onMouseEnter={()=>setHoverImagen(1)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 1 ? img_wsp_hover : img_wsp} style={{width:'100%'}} alt="video" /></a>
        :
        <a  onClick={()=>onMetrica('whatsapp',nombre)} target="_blank" href="https://api.whatsapp.com/send?phone=525513042767&text=Hello,%20I%20am%20contacted%20from%20the%20Lutron%20booth%20at%20IES." onMouseEnter={()=>setHoverImagen(1)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 1 ? img_wsp_en_hover : img_wsp_en} style={{width:'100%'}} alt="video" /></a>}
        </Col>
        <Col xs={{span:20, offset:2}} md={{span:8, offset:0}} className="paddin_20">
        {idioma === 'es' ?
        <a  onClick={()=>onMetrica('mail',nombre)} target="_blank" href="mailto:csvazquez@lutron.com" onMouseEnter={()=>setHoverImagen(2)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 2 ? img_email_hover : img_email} style={{width:'100%'}} alt="video" /></a>
      :
      <a  onClick={()=>onMetrica('mail',nombre)} target="_blank" href="mailto:csvazquez@lutron.com" onMouseEnter={()=>setHoverImagen(2)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 2 ? img_email_en_hover : img_email_en} style={{width:'100%'}} alt="video" /></a>}
        </Col>
       </Row>
      <Row>
        <Col span={16} offset={4}>
          <br /><br />
        </Col>
        <Col span={20} offset={2}>
          <p className="titulo_patrocinador_texto">PREGUNTAS FRECUENTES</p>
        </Col>
        <Col span={20} offset={2}>
          <Collapse
            bordered={false}
            defaultActiveKey={['1']}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            className="site-collapse-custom-collapse"
          >
            {idioma === 'es' ?
            <Panel header="¿Cuáles son sus más recientes productos?" key="1" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Athena:	<a target="_blank" className="texto_patrocinadores_link" href="https://www.lutron.com/es-LA/products/paginas/wholebuildingsystems/athena/overview.aspx">https://www.lutron.com/es-LA/products/paginas/wholebuildingsystems/athena/overview.aspx</a>
                  <br /><br />
                  Ketra:	<a target="_blank" className="texto_patrocinadores_link" href="https://www.ketra.com/resources">https://www.ketra.com/resources</a>
                  <br /><br />
                  Alisse:	<a target="_blank" className="texto_patrocinadores_link" href="https://www.lutron.com/es-LA/products/paginas/components/alisse/overview.aspx">https://www.lutron.com/es-LA/products/paginas/components/alisse/overview.aspx</a>
                  </p>
            </Panel>
            :
            <Panel header="What are your latest products?" key="1" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Athena:	<a target="_blank" className="texto_patrocinadores_link" href="https://www.lutron.com/es-LA/products/paginas/wholebuildingsystems/athena/overview.aspx">https://www.lutron.com/es-LA/products/paginas/wholebuildingsystems/athena/overview.aspx</a>
                  <br /><br />
                  Ketra:	<a target="_blank" className="texto_patrocinadores_link" href="https://www.ketra.com/resources">https://www.ketra.com/resources</a>
                  <br /><br />
                  Alisse:	<a target="_blank" className="texto_patrocinadores_link" href="https://www.lutron.com/es-LA/products/paginas/components/alisse/overview.aspx">https://www.lutron.com/es-LA/products/paginas/components/alisse/overview.aspx</a>
                  </p>
            </Panel>
            }
            {idioma === 'es' ?
            <Panel header="¿Dónde puedo comprar sus productos?" key="2" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Vendemos a través de diferentes canales con dealers autorizados, especializados en residencial, comercial, hotelería y electrical wholesellers. Si estas interesado en los siguientes mercados por favor contactar a:
                  <br /><br />
                  Residencial: Andrés Olguín <a target="_blank" className="texto_patrocinadores_link" href="mailto:Aolguin@lutron.com">Aolguin@lutron.com</a><br />
                  Comercial: Carlos Arias <a target="_blank" className="texto_patrocinadores_link" href="mailto:Carias@lutron.com">Carias@lutron.com</a><br />
                  Hotelería: Eduardo Espinosa <a target="_blank" className="texto_patrocinadores_link" href="mailto:Eespinosa@lutron.com">Eespinosa@lutron.com</a><br />
                  OEM: Gilberto De La Torre <a target="_blank" className="texto_patrocinadores_link" href="mailto:gdelatorre@lutron.com">gdelatorre@lutron.com</a><br />
                  Persianas: Carlos Vázquez <a target="_blank" className="texto_patrocinadores_link" href="mailto:csvazquez@lutron.com">csvazquez@lutron.com</a><br />
                  </p>
            </Panel>
            :
            <Panel header="Where can I buy your products?" key="2" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  We sell through different channels with authorized dealers, specialized in residential, commercial, hotel and electrical wholesellers. If you are interested in the following markets please contact:
                  <br /><br />
                  Residential: Andrés Olguín <a target="_blank" className="texto_patrocinadores_link" href="mailto:Aolguin@lutron.com">Aolguin@lutron.com</a><br />
                  Commercial: Carlos Arias <a target="_blank" className="texto_patrocinadores_link" href="mailto:Carias@lutron.com">Carias@lutron.com</a><br />
                  Hospitality: Eduardo Espinosa <a target="_blank" className="texto_patrocinadores_link" href="mailto:Eespinosa@lutron.com">Eespinosa@lutron.com</a><br />
                  OEM: Gilberto De La Torre <a target="_blank" className="texto_patrocinadores_link" href="mailto:gdelatorre@lutron.com">gdelatorre@lutron.com</a><br />
                  Blinds: Carlos Vázquez <a target="_blank" className="texto_patrocinadores_link" href="mailto:csvazquez@lutron.com">csvazquez@lutron.com</a><br />
                  </p>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Lutron puede ayudarme a especificar un proyecto?" key="3" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Lutron cuenta con un equipo de especificación en México, el cual te ayudará en el desarrollo y especificación de cualquier tipo de proyecto residencial, comercial, hoteleria o industrial. Si estas interesado por favor contactar a:
                  <br /><br />
                  Carlos Vázquez <a target="_blank" className="texto_patrocinadores_link" href="mailto:csvazquez@lutron.com">csvazquez@lutron.com</a><br />
                  Gilberto de la Torre <a target="_blank" className="texto_patrocinadores_link" href="mailto:gdelatorrre@lutron.com">gdelatorrre@lutron.com</a><br />
                  </p>
            </Panel>
            :
            <Panel header="Can Lutron help me specify a project?" key="3" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Lutron has a specification team in Mexico, which will help you in the development and specification of any type of residential, commercial, hotel or industrial project. If you are interested please contact:
                  <br /><br />
                  Carlos Vázquez <a target="_blank" className="texto_patrocinadores_link" href="mailto:csvazquez@lutron.com">csvazquez@lutron.com</a><br />
                  Gilberto de la Torre <a target="_blank" className="texto_patrocinadores_link" href="mailto:gdelatorrre@lutron.com">gdelatorrre@lutron.com</a><br />
                  </p>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Qué ofertas de productos tiene Lutron?" key="4" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Lutron es el líder en la industria en control de iluminación natural y artificial a través de nuestro amplio portafolio.
                  </p>
            </Panel>
            :
            <Panel header="What product offerings does Lutron have?" key="4" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Lutron is the industry leader in daylight and artificial lighting control through our extensive portfolio.
                  </p>
            </Panel>}
           {idioma === 'es' ? 
           <Panel header="¿Dónde puedo tener acceso a cursos y entrenamientos de productos LUTRON? " key="5" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Los entrenamientos son impartidos de diferentes formas. Tenemos un portal que se llama LCI (<a target="_blank" className="texto_patrocinadores_link" href="https://www.lutron.com/en-US/Pages/LutronLCIOnline.aspx">https://www.lutron.com/en-US/Pages/LutronLCIOnline.aspx</a>), en el cual puedes registrarte para tomar cursos en línea y puedes obtener capacitaciones por producto con los diferentes distribuidores y con el equipo de LUTRON en México. 
                  <br />
                  Si te interesa algún entrenamiento en específico puedes contactar a los siguientes líderes.
                  <br /><br />
                  Residencial:	Andrés Olguín		<a target="_blank" className="texto_patrocinadores_link" href="mailto:Aolguin@lutron.com">Aolguin@lutron.com</a><br />
Comercial: Carlos Arias <a target="_blank" className="texto_patrocinadores_link" href="mailto:Carias@lutron.com">Carias@lutron.com</a><br />
Hotelería: Eduardo Espinosa <a target="_blank" className="texto_patrocinadores_link" href="mailto:Eespinosa@lutron.com">Eespinosa@lutron.com</a><br />
OEM: Gilberto De La Torre <a target="_blank" className="texto_patrocinadores_link" href="mailto:gdelatorre@lutron.com">gdelatorre@lutron.com</a><br />
Persianas: Carlos Vázquez <a target="_blank" className="texto_patrocinadores_link" href="mailto:csvazquez@lutron.com">csvazquez@lutron.com</a><br />

                  </p>
            </Panel>
            :
            <Panel header="Where can I access LUTRON product courses and trainings?" key="5" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            The trainings are given in different ways. We have a portal called LCI (<a target="_blank" className="texto_patrocinadores_link" href="https://www.lutron.com/en-US/Pages/LutronLCIOnline.aspx">https://www.lutron.com/en-US/Pages/LutronLCIOnline.aspx</a>), register to take online courses and you can get training by product with the different distributors and with the LUTRON team in Mexico.
            <br />
            If you are interested in any specific training you can contact the following leaders.
            <br /><br />
            Residential:	Andrés Olguín		<a target="_blank" className="texto_patrocinadores_link" href="mailto:Aolguin@lutron.com">Aolguin@lutron.com</a><br />
            Commercial: Carlos Arias <a target="_blank" className="texto_patrocinadores_link" href="mailto:Carias@lutron.com">Carias@lutron.com</a><br />
            Hospitality: Eduardo Espinosa <a target="_blank" className="texto_patrocinadores_link" href="mailto:Eespinosa@lutron.com">Eespinosa@lutron.com</a><br />
OEM: Gilberto De La Torre <a target="_blank" className="texto_patrocinadores_link" href="mailto:gdelatorre@lutron.com">gdelatorre@lutron.com</a><br />
Blinds:  Carlos Vázquez <a target="_blank" className="texto_patrocinadores_link" href="mailto:csvazquez@lutron.com">csvazquez@lutron.com</a><br />
            </p>
      </Panel>}
           {idioma === 'es' ?
           <Panel header="¿Con qué otros dispositivos se puede integrar LUTRON?" key="6" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  LUTRON es una marca que con diferentes tipos de productos para proyectos comerciales, residenciales, hoteleros e industriales, por mencionar algunos. 
                  <br />
                  Ofrece una fácil integración como ninguna otra con los principales jugadores en la industria de integración; como Crestron, Savant, Elan, RTI, Control4, Universal Remote, por mencionar algunos. 
                  <br />
                  Los clientes confían la solución de control de iluminación a Lutron por su gran desempeño, diseño y calidad; y se ha establecido como una solución que simplemente funciona con los mejores.
                  </p>
            </Panel>
            :
            <Panel header="What other devices can LUTRON integrate with?" key="6" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            LUTRON is a brand with different types of products for commercial, residential, hotel and industrial projects, to name a few.
            <br />
Offers easy integration like no other with major players in the integration industry; like Crestron, Savant, Elan, RTI, Control4, Universal Remote, to name a few.
<br />
Los clientes confían la solución de control de iluminación a Lutron por su gran desempeño, diseño y calidad; y se ha establecido como una solución que simplemente funciona con los mejores.

            </p>
      </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Los drivers LUTRON sólo funcionan con controladores de la misma marca" key="7" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Al tener presencia en diferentes mercados como lo es el residencial, LUTRON ofrece un amplio portafolio de drivers para atenuación en fase. <br />
                  Es uno de los más grandes del mercado donde podemos encontrar un driver con atenuación máxima del 5%,1% y 0.1% para casi todos los luminarios existentes para este tipo de aplicaciones.
                  </p>
            </Panel>
            :
            <Panel header="Do LUTRON drivers only work with drivers of the same brand?" key="7" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  By having a presence in different markets such as residential, LUTRON offers a wide portfolio of drivers for phase dimming.<br />
                  It is one of the largest on the market where we can find a driver with a maximum attenuation of 5%, 1% and 0.1% for almost all existing luminaires for this type of application.
                  </p>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Cuál es la compatibilidad de los atenuadores LUTRON con los diferentes tipos de lámparas LED en el mercado?" key="8" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  LUTRON en la búsqueda de garantizar la funcionalidad de sus productos, realiza una amplia seria de pruebas con las lámparas de la industria de iluminación, publicando los resultados en su pagina web, para que los usuarios estén tranquilos y confiados en la funcionalidad de los equipos que utilizan. A continuación, se comparte el link:
                  <br />
                  <a target="_blank" className="texto_patrocinadores_link" href="https://www.lutron.com/en-US/Pages/LEDCompatibilityTool/Compatibility.aspx">https://www.lutron.com/en-US/Pages/LEDCompatibilityTool/Compatibility.aspx</a>
                  </p>
            </Panel>
            :
            <Panel header="What is the compatibility of LUTRON dimmers with the different types of LED lamps on the market?" key="8" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  LUTRON in the search to guarantee the functionality of its products, carries out a wide series of tests with the lamps of the lighting industry, publishing the results on its website, so that users are calm and confident in the functionality of the equipment they they use. Next, the link is shared:
                  <br />
                  <a target="_blank" className="texto_patrocinadores_link" href="https://www.lutron.com/en-US/Pages/LEDCompatibilityTool/Compatibility.aspx">https://www.lutron.com/en-US/Pages/LEDCompatibilityTool/Compatibility.aspx</a>
                  </p>
            </Panel>}
          </Collapse>
        </Col>
        <Col span={20} offset={2}>
        <br /><br />
        {idioma === 'es' ?
        <p className="tituLogos">Obtener más información</p>
        :
        <p className="tituLogos">Get more information</p>}
        </Col>
        <Col xs={{span:10,offset:7}} md={{span:6,offset:9}}>
        
        <Row>
          <Col span={6} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('facebook',nombre)} href="https://www.facebook.com/lutronlatam" target="_blank" onMouseEnter={()=>setHoverRedes(1)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 1 ? btn_fb_hover : btn_fb} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={6} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('twitter',nombre)} href="https://twitter.com/lutron" target="_blank" onMouseEnter={()=>setHoverRedes(2)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 2 ? btn_tw_hover : btn_tw} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={6} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('youtube',nombre)} href="https://www.youtube.com/channel/UCn7U4ssE8-aRMUXPi_plB9Q" target="_blank" onMouseEnter={()=>setHoverRedes(3)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 3 ? btn_yt_hover : btn_yt} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={6} className="contenedor_redes_patrocinadores contenedor_redes_patrocinadores_rigth">
            <a onClick={()=>onMetrica('instagram',nombre)} href="https://www.instagram.com/lutronlatinoamerica/" target="_blank" onMouseEnter={()=>setHoverRedes(4)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 4 ? btn_in_hover : btn_in} className="patrocinadores_redes_img" /></a>
          </Col>
        </Row>
        <br />
        </Col>
      </Row>
    </>
  )
}
export default Lutron;